import React, { useEffect, useState } from 'react';

import PropTypes from 'prop-types';

import styled from 'styled-components';

import { LightButton } from 'apps/promo/components/common/fromAuth/LightButton/LightButton';
import { LightIcon } from 'apps/promo/components/common/fromAuth/LightIcon/LightIcon';
import { LightText } from 'apps/promo/components/common/fromAuth/LightText/LightText';
import { PromoRow } from 'apps/promo/components/common/PromoRow/PromoRow';

const EmptyContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: ${(props) => (props.$hasFixedIndent ? null : 'center')};
    align-items: flex-start;
    flex: ${(props) => (props.$isKeyboardOpened ? null : 1)};
    height: ${(props) => props.$viewportHeight};
    padding-top: ${(props) => (props.$hasFixedIndent ? '40px' : null)};
`;

export const PromoEmptyPage = (props) => {
    const [isKeyboardOpened, setIsKeyboardOpened] = useState(false);
    const [viewportHeight, setViewportHeight] = useState('auto');

    const checkKeyboardOpened = () => {
        const initialScreenSize = window.innerHeight;
        const viewportHeight = window.visualViewport.height;
        if (viewportHeight < initialScreenSize) {
            setIsKeyboardOpened(true);
            setViewportHeight(window.visualViewport.height + 'px');
        } else {
            setIsKeyboardOpened(false);
            setViewportHeight('auto');
        }
    };

    useEffect(() => {
        checkKeyboardOpened();
        window.visualViewport.addEventListener('resize', () => checkKeyboardOpened());

        return () => {
            window.visualViewport.removeEventListener('resize', () => checkKeyboardOpened());
        };
    }, []);

    return (
        <EmptyContainer $viewportHeight={viewportHeight} $isKeyboardOpened={isKeyboardOpened} $hasFixedIndent={props.hasFixedIndent}>
            <PromoRow indent="16px">
                <LightIcon name={'ghost'} color="secondary" />
            </PromoRow>
            <PromoRow indent={props.showChat ? '16px' : null}>
                <LightText color="secondary">{props.notFoundMessage}</LightText>
            </PromoRow>
            {props.showChat && (
                <LightButton
                    caption={props.chatButton}
                    variant={'row'}
                    type={props.chatButtonType ? props.chatButtonType : 'button'}
                    href={props.chatButtonHref ? props.chatButtonHref : null}
                    onClick={props.toggleChat}
                    negativeMargin
                    id={props.buttonId}
                />
            )}
        </EmptyContainer>
    );
};

PromoEmptyPage.propTypes = {
    notFoundMessage: PropTypes.string,
    chatButtonType: PropTypes.string,
    chatButtonHref: PropTypes.string,
    showChat: PropTypes.bool,
    chatButton: PropTypes.string,
    toggleChat: PropTypes.func,
    useThemeColor: PropTypes.bool,
    buttonId: PropTypes.string,
    hasFixedIndent: PropTypes.bool,
};
